import { Button } from "antd";
import styled from "styled-components";
import { color } from "../../res/colors";

export const CancelButton = styled(Button)`
  border-radius: 8px;
  background: ${color.DISABLED};
  border-color: ${color.DISABLED};
  width: ${(p) => (p.width ? p.width : "100%")} !important;

  height: 32px;
  color: ${color.WHITE};
  &:hover {
    opacity: 0.8;
    background: ${color.DISABLED};
    border-color: ${color.DISABLED};
    color: ${color.WHITE};
  }
  &:focus {
    background: ${color.DISABLED};
    color: ${color.WHITE};
    opacity: 0.8;
  }
`;
